<template>
  <div>
    <b-navbar id="header" class="position-sticky" align="center" type="light" variant="white"
      fixed="top">
      <b-navbar-brand :to="{name:'index'}">
        <img :src="FilePath+system.CompanyImage" alt="Company LOGO" style="max-width:130px" />
      </b-navbar-brand>

      <b-navbar-nav class="overflow-x-auto text-nowrap ml-auto" v-if='logindata.check'>
        <b-nav-item :to="{name:'myorder'}" class="mynavbtn">我的訂單</b-nav-item>
        <b-nav-item :to="{name:'proOverview'}" class="mynavbtn">商品管理</b-nav-item>
        <b-nav-item :to="{name:'cartManage'}" class="mynavbtn">購物車管理</b-nav-item>
        <b-nav-item :to="{name:'webSetting'}" class="mynavbtn">網站設定</b-nav-item>
        <!-- 
        <b-nav-item :to="{name:'memberinformation'}" class="mynavbtn">會員資料</b-nav-item>
        <b-nav-item :to="{name:'changepassword'}" class="mynavbtn">修改密碼</b-nav-item>
        <b-nav-item :to="{name:'courseleave'}" class="mynavbtn">課程請假</b-nav-item>
        <b-nav-item :to="{name:'onlineService'}" class="mynavbtn">線上客服</b-nav-item> 
        -->
        <b-nav-item :to="{name:'epaper'}" class="mynavbtn">電子報</b-nav-item>
        <b-nav-item :to="{name:'logout'}" class="mynavbtn">登出</b-nav-item>
      </b-navbar-nav>

      <b-navbar-nav class="overflow-x-auto text-nowrap ml-auto" v-if='!logindata.check'>
        <b-nav-item href="http://www.magee.tw">回至前台</b-nav-item>
      </b-navbar-nav>
    </b-navbar>
  </div>
</template>
<script>
  import ctrl from "./js/header.js";
  export default ctrl;

</script>
